import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { useGetClientProfileQuery } from "store/api";
import { useAppSelector } from "store/hooks/useAppSelector";
import styles from "./MainClientInfo.styled";

const MainClientInfo = () => {
  const { data: clientData, isSuccess } = useGetClientProfileQuery();
  const currency = useAppSelector((state) => state.settings.currency);

  return (
    <Box sx={styles.tablesWrap}>
      {isSuccess && (
        <>
          <TableContainer>
            <Table sx={styles.table}>
              <TableBody>
                <TableRow>
                  <TableCell
                    align="left"
                    sx={{ ...styles.tableCell, ...styles.tableHeadCell }}
                  >
                    Прізвище:
                  </TableCell>
                  <TableCell align="left" sx={styles.tableCell}>
                    <Box component="span">{clientData.user_first_name}</Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    align="left"
                    sx={{ ...styles.tableCell, ...styles.tableHeadCell }}
                  >
                    Імʼя:
                  </TableCell>
                  <TableCell align="left" sx={styles.tableCell}>
                    <Box component="span">{clientData.user_middle_name}</Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    align="left"
                    sx={{ ...styles.tableCell, ...styles.tableHeadCell }}
                  >
                    По батькові:
                  </TableCell>
                  <TableCell align="left" sx={styles.tableCell}>
                    <Box component="span">{clientData.user_last_name}</Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    align="left"
                    sx={{ ...styles.tableCell, ...styles.tableHeadCell }}
                  >
                    Телефон:
                  </TableCell>
                  <TableCell align="left" sx={styles.tableCell}>
                    <Box component="span">{clientData.user_phone}</Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <TableContainer>
            <Table sx={styles.table}>
              <TableBody>
                <TableRow>
                  <TableCell
                    align="left"
                    sx={{ ...styles.tableCell, ...styles.tableHeadCell }}
                  >
                    Кількість замолень:
                  </TableCell>
                  <TableCell align="left" sx={styles.tableCell}>
                    <Box component="span">{clientData.orders_count}</Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    align="left"
                    sx={{ ...styles.tableCell, ...styles.tableHeadCell }}
                  >
                    Знижка:
                  </TableCell>
                  <TableCell align="left" sx={styles.tableCell}>
                    <Box component="span">{`${clientData.discount.value} ${clientData.discount.unit}`}</Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    align="left"
                    sx={{ ...styles.tableCell, ...styles.tableHeadCell }}
                  >
                    Бонуси:
                  </TableCell>
                  <TableCell align="left" sx={styles.tableCell}>
                    <Box component="span">{`${clientData.client_bonuses}${currency}`}</Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <TableContainer>
            <Table sx={styles.table}>
              <TableBody>
                <TableRow>
                  <TableCell
                    align="left"
                    sx={{ ...styles.tableCell, ...styles.tableHeadCell }}
                  >
                    Адреса:
                  </TableCell>
                  <TableCell align="left" sx={styles.tableCell}>
                    <Box component="span">{clientData.route_address_from}</Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    align="left"
                    sx={{ ...styles.tableCell, ...styles.tableHeadCell }}
                  >
                    Будинок:
                  </TableCell>
                  <TableCell align="left" sx={styles.tableCell}>
                    <Box component="span">
                      {clientData.route_address_number_from || ""}
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    align="left"
                    sx={{ ...styles.tableCell, ...styles.tableHeadCell }}
                  >
                    Підʼїзд:
                  </TableCell>
                  <TableCell align="left" sx={styles.tableCell}>
                    <Box component="span">
                      {clientData.route_address_entrance_from || ""}
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    align="left"
                    sx={{ ...styles.tableCell, ...styles.tableHeadCell }}
                  >
                    Квартира:
                  </TableCell>
                  <TableCell align="left" sx={styles.tableCell}>
                    <Box component="span">
                      {clientData.route_address_apartment_from || ""}
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </Box>
  );
};

export default MainClientInfo;
